<p>case-request-detail-files works!</p>
